import { render, staticRenderFns } from "./Weixin.vue?vue&type=template&id=d7b8e284&scoped=true&"
import script from "./Weixin.vue?vue&type=script&lang=js&"
export * from "./Weixin.vue?vue&type=script&lang=js&"
import style0 from "./Weixin.vue?vue&type=style&index=0&id=d7b8e284&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b8e284",
  null
  
)

export default component.exports